import { render, staticRenderFns } from "./batch-user.vue?vue&type=template&id=07b3029d&"
import script from "./batch-user.vue?vue&type=script&lang=js&"
export * from "./batch-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports